import { Dispatch, SetStateAction } from 'react';
import { LayoutStage } from './StreamChat';
import { ReactElement } from 'react';
import { useChannelActionContext, useChannelStateContext } from 'stream-chat-react';
import { useEffect } from 'react';

export default function ChannelLayoutManager({
  layout,
  setLayout,
  children,
}: {
  layout: LayoutStage;
  setLayout: Dispatch<SetStateAction<LayoutStage>>;
  children: ReactElement;
}) {
  const { channel, thread } = useChannelStateContext();
  const { closeThread } = useChannelActionContext();

  useEffect(() => {
    if (layout === 'search' && thread !== null) {
      closeThread();
    }
  }, [layout]);

  useEffect(() => {
    if (layout === 'search' && !thread) return;
    if (thread) {
      setLayout('thread');
    } else if (channel) {
      setLayout('channel');
    } else {
      setLayout('list');
    }
  }, [channel, thread]);

  return children;
}
